
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.636 10.18H8.644a.413.413 0 00-.384.384v10.752c0 .192.192.384.384.384h4.992a.413.413 0 00.384-.384V10.564a.413.413 0 00-.384-.384zM8.644 8.26h12.672a.413.413 0 00.384-.384V3.46c0-.576-.384-.96-.96-.96H8.644a.413.413 0 00-.384.384v4.992c0 .192.192.384.384.384zM15.94 10.564v10.752c0 .192.191.384.383.384h4.416c.576 0 .96-.384.96-.96V10.564a.413.413 0 00-.384-.384h-4.992a.413.413 0 00-.383.384zM5.956 2.5H3.46c-.576 0-.96.384-.96.96v17.28c0 .576.384.96.96.96h2.496a.413.413 0 00.384-.384V2.884a.413.413 0 00-.384-.384z","fill":"#B5B8B5"}})])
          )
        }
      }
    